import { Box, FormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const StyledFormControl = styled(FormControl)<{ isopen?: string }>`
  background: transparent;
  outline: none;
  border: 0;
  display: flex;
  color: ${theme.colors.foreground};
  text-align: center;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  letter-spacing: 0.1px;

  ${({ isopen }) =>
    isopen === 'true' &&
    `
      color: ${theme.colors.cta};
  `};

  .is-open {
    path {
      stroke: ${theme.colors.cta};
    }
  }

  .MuiOutlinedInput-root {
    background: transparent;
    border: 0;
    outline: 0;
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    color: ${({ isopen }) => (isopen && isopen === 'true' ? theme.colors.cta : theme.colors.menuItemText)};
    gap: ${theme.spacing.xSmall}px;

    > * {
      border: none !important;
      outline: none !important;
    }

    .MuiSelect-select {
      padding: 0 46px 0 0;
    }
  }

  &:hover {
    svg {
      path {
        stroke: ${theme.colors.cta};
      }
    }

    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }
  }

  svg {
    top: calc(50% - 0.6em);
    right: ${theme.spacing.small}px;
  }

  fieldset {
    padding: 0;
  }
`

export const menuProps = {
  PaperProps: {
    sx: {
      backgroundColor: theme.colors.menuBg,
      transform: `translateY(${theme.spacing.xSmall}px) !important`,
      borderRadius: `${theme.spacing.md}px`,
      boxShadow: 'none',
      width: 244,

      "html[data-theme='light'] &": {
        backgroundColor: theme.colors.surfaceContainerBackground
      },

      '& ul': {
        paddingTop: 0,
        paddingBottom: 0
      },

      '& .MuiMenuItem-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: `10px ${theme.spacing.small}px`,
        cursor: 'pointer',
        color: theme.colors.menuItemText,
        fontSize: '14px',

        '&:first-of-type': {
          paddingTop: '16px'
        },

        '&:last-of-type': {
          paddingBottom: '16px'
        },

        '&:hover, &.Mui-selected:hover': {
          backgroundColor: theme.colors.surfaceContainerBackground,
          color: theme.colors.cta,

          '& svg': {
            color: theme.colors.cta
          },

          "html[data-theme='light'] &": {
            backgroundColor: theme.colors.menuItemHover
          }
        },

        '&.Mui-selected': {
          backgroundColor: theme.colors.surfaceContainerBackground,
          color: theme.colors.cta,

          "html[data-theme='light'] &": {
            backgroundColor: theme.colors.cardFillTertiary
          }
        },

        '& svg': {
          fontSize: `${theme.iconSize.small}px`
        }
      }
    },
    style: {
      maxHeight: 250
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
